/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Br as Br,
  rec_DetalleTarea as DetalleTarea,
  rec_EstadoError as EstadoError,
  rec_JSXRuntime as JSXRuntime,
  rec_Modal as Modal,
  rec_QS as QS,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Sn as Sn,
  rec_XS as XS,
  rec_ZS as ZS,
  rec_api as api,
  rec_ii as ii,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function TarjetaTarea(e) {
  let t = (0, ReactCompiler.c)(30),
    { tareaId: n, onClose: r, onCambio: i } = e,
    [a, o] = (0, React.useState)(null),
    [s, c] = (0, React.useState)(null),
    [l, u] = (0, React.useState)(``),
    f;
  t[0] === n
    ? (f = t[1])
    : ((f = async () => {
        u(``);
        try {
          let e = await api(`/tareas/${n}`);
          if (!e.proyectoId) {
            (o(e),
              c({
                id: null,
                unidadId: e.unidadId,
                nombre: e.unidadNombre,
                miRol: `COLABORADOR`,
                miembros: [],
                metas: [],
                etiquetas: [],
                listas: [],
              }));
            return;
          }
          let [t, r, i, a] = await Promise.all([
            api(`/proyectos/${e.proyectoId}`),
            api(`/metas?proyecto=${e.proyectoId}`).catch(QS),
            api(`/etiquetas?proyecto=${e.proyectoId}`).catch(ZS),
            api(`/listas?proyecto=${e.proyectoId}`).catch(XS),
          ]);
          (o(e),
            c({
              ...t,
              metas: r,
              etiquetas: i,
              listas: a,
            }));
        } catch (e) {
          u(e.message);
        }
      }),
      (t[0] = n),
      (t[1] = f));
  let p = f,
    m,
    h;
  if (
    (t[2] === p
      ? ((m = t[3]), (h = t[4]))
      : ((m = () => {
          p();
        }),
        (h = [p]),
        (t[2] = p),
        (t[3] = m),
        (t[4] = h)),
    (0, React.useEffect)(m, h),
    l)
  ) {
    let e;
    t[5] !== p || t[6] !== l
      ? ((e = <EstadoError mensaje={l} onReintentar={p} />),
        (t[5] = p),
        (t[6] = l),
        (t[7] = e))
      : (e = t[7]);
    let n;
    t[8] === r
      ? (n = t[9])
      : ((n = (
          <div
            className={`mt-3 flex justify-end`}
            children={
              <button
                type={`button`}
                onClick={r}
                className={zo}
                children={`Cerrar`}
              />
            }
          />
        )),
        (t[8] = r),
        (t[9] = n));
    let i;
    return (
      t[10] !== r || t[11] !== e || t[12] !== n
        ? ((i = <Modal titulo={`Tarea`} onClose={r} children={[e, n]} />),
          (t[10] = r),
          (t[11] = e),
          (t[12] = n),
          (t[13] = i))
        : (i = t[13]),
      i
    );
  }
  if (!a || !s) {
    let e;
    t[14] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((e = (
          <div
            className={`flex items-center gap-2 text-sm text-(--text)`}
            children={[
              (0, JSXRuntime.jsx)(ii, {
                className: `h-4 w-4 animate-spin`,
              }),
              ` Cargando…`,
            ]}
          />
        )),
        (t[14] = e))
      : (e = t[14]);
    let n;
    return (
      t[15] === r
        ? (n = t[16])
        : ((n = <Modal titulo={`Tarea`} onClose={r} children={e} />),
          (t[15] = r),
          (t[16] = n)),
      n
    );
  }
  let _;
  t[17] !== i || t[18] !== r
    ? ((_ = () => {
        (i?.(), r());
      }),
      (t[17] = i),
      (t[18] = r),
      (t[19] = _))
    : (_ = t[19]);
  let v = a.proyectoId
      ? `/proyectos/${a.proyectoId}`
      : `/organizacion/${a.unidadId}`,
    y;
  t[20] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((y = <Br className={`h-3.5 w-3.5`} />), (t[20] = y))
    : (y = t[20]);
  let b = a.proyectoId ? `Abrir el proyecto ${s.nombre}` : `Abrir ${s.nombre}`,
    x;
  t[21] !== v || t[22] !== b
    ? ((x = (
        <Sn
          to={v}
          className={`flex w-fit items-center gap-1 text-xs text-(--text) hover:text-(--accent) hover:underline`}
          children={[y, b]}
        />
      )),
      (t[21] = v),
      (t[22] = b),
      (t[23] = x))
    : (x = t[23]);
  let S;
  return (
    t[24] !== r || t[25] !== s || t[26] !== _ || t[27] !== x || t[28] !== a
      ? ((S = (
          <DetalleTarea
            tarea={a}
            proyecto={s}
            metas={s.metas}
            etiquetas={s.etiquetas}
            listas={s.listas}
            onClose={r}
            onGuardado={_}
            encabezadoExtra={x}
          />
        )),
        (t[24] = r),
        (t[25] = s),
        (t[26] = _),
        (t[27] = x),
        (t[28] = a),
        (t[29] = S))
      : (S = t[29]),
    S
  );
}
